<div class="td flex layout-row layout-align-start-center full-height" [style.width.px]="dayColWidth"
     [style.minWidth.px]="dayColWidth" [style.maxWidth.px]="dayColWidth">
  <!-- deliveryEtd - clickable for editors -->
  <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
    <div *ngIf="tableFilterColumns.isDisplayDeliveryEtd" class="br-body-1 font-weight-400 gray-100 flex-15 cell-text">
      <span *ngIf="hasDelivery" class="delivery"
            [ngClass]="{
            'warn': !!isDeliveryEtdNextDay || !!isDeliveryEtdPreviousDay,
            'actual': !!cell.deliveryDetails?.deliveryEtd?.initial && cell.deliveryDetails?.deliveryEtd?.adjusted?.value && cell.deliveryDetails?.deliveryEtd?.adjusted?.source === 'Actual',
            'actual-orange': !cell.deliveryDetails?.isDeliveryDay?.initial?.value && !!cell.deliveryDetails?.isDeliveryDay?.adjusted?.value && cell.deliveryDetails?.isDeliveryDay?.adjusted?.source === 'Actual',
            }"
            [ngbTooltip]="deliveryTooltipTmpl"
            openDelay="300"
            container="body"
            triggers="hover">
            D
        <bringoz-icon *ngIf="hasDelivery && cell.deliveryDetails?.multipleDeliveries" iconName="group" classSize="sm"></bringoz-icon>

        <ng-template #deliveryTooltipTmpl>
          <div class="layout-column">
            <div class="layout-row layout-align-start-center gap-5">
              <bringoz-icon iconName="etd" classSize="xl" class="gray-101"></bringoz-icon>
              <span *ngIf="!!isDeliveryEtdNextDay || !!isDeliveryEtdPreviousDay" translate>{{isDeliveryEtdNextDay ? 'Next day' : 'Previous day'}}</span>
              <div *ngIf="cell.deliveryDetails?.deliveryEtd?.adjusted?.value" class="layout-column">
                <span>{{ {etd: cell.deliveryDetails.deliveryEtd.adjusted.value} | bringozTime: 'etd' }}</span>
                <span style="text-decoration: line-through;">{{ {etd: cell.deliveryDetails.deliveryEtd.initial.value} | bringozTime: 'etd' }}</span>
              </div>
              <span *ngIf="!cell.deliveryDetails?.deliveryEtd?.adjusted?.value">
                {{ {etd: getFieldValue(cell.deliveryDetails.deliveryEtd)} | bringozTime: 'etd' }}
              </span>
              <span *ngIf="!!isDeliveryEtdNextDay || !!isDeliveryEtdPreviousDay">
                {{ {etd: getFieldValue(cell.deliveryDetails.deliveryEtd)} | bringozDate: 'etd' }}
              </span>
            </div>
          </div>
        </ng-template>
      </span>
    </div>
  </ng-container>
  <!-- deliveryEtd - read-only for viewers -->
  <ng-container *ngxPermissionsExcept="'schedulingProject.visitPlan.update'">
    <div *ngIf="tableFilterColumns.isDisplayDeliveryEtd" class="br-body-1 font-weight-400 gray-100 flex-15 cell-text">
      <span *ngIf="hasDelivery" class="delivery"
            [ngClass]="{'actual': cell.deliveryDetails?.deliveryEtd?.adjusted?.value && cell.deliveryDetails?.deliveryEtd?.adjusted?.source === 'Actual'}"
            [ngbTooltip]="deliveryTooltipTmplReadonly"
            openDelay="300"
            container="body"
            triggers="hover">
            D
        <bringoz-icon *ngIf="cell.deliveryDetails?.multipleDeliveries" iconName="group" classSize="sm"></bringoz-icon>
        <ng-template #deliveryTooltipTmplReadonly>
          <div class="layout-column">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="etd" classSize="xl" class="gray-101"></bringoz-icon>
              <div *ngIf="cell.deliveryDetails?.deliveryEtd?.adjusted?.value" class="layout-column margin-left-5">
                <span>{{ {etd: cell.deliveryDetails.deliveryEtd.adjusted.value} | bringozTime: 'etd' }}</span>
                <span style="text-decoration: line-through;">{{ {etd: cell.deliveryDetails.deliveryEtd.initial.value} | bringozTime: 'etd' }}</span>
              </div>
              <span *ngIf="!cell.deliveryDetails?.deliveryEtd?.adjusted?.value" class="margin-left-5">
                {{ {etd: getFieldValue(cell.deliveryDetails.deliveryEtd)} | bringozTime: 'etd' }}
              </span>
            </div>
          </div>
        </ng-template>
      </span>
    </div>
  </ng-container>
    <!--    {{ cellTotals.merchandiseUnitsCount || 0 }}-->
  <!-- deliveryUnits -->
  <div *ngIf="tableFilterColumns.isDisplayDeliveryUnits" class="br-body-1 font-weight-400 gray-100 flex-10 cell-text">
    <div
      *ngIf="hasAdjustedDeliveryUnits()"
      class="layout-column">
      <span>{{ cellCopy.deliveryDetails.deliveryUnits?.adjusted?.value || 0 | number }}</span>
      <span class="line-through">{{ cellCopy.deliveryDetails.deliveryUnits?.initial?.value || 0 | number }}</span>
    </div>
    <span
      *ngIf="!hasAdjustedDeliveryUnits()">
      {{ getFieldValue(cellCopy.deliveryDetails.deliveryUnits) || 0 | number }}</span>
  </div>
  <!-- Call Types  -->
  <div *ngIf="tableFilterColumns.isDisplayCallTypes" class="flex layout-row layout-align-start-center cell-edit" (mouseenter)="isShowEditBtn = true"
       (mouseleave)="isShowEditBtn = false"
       (click)="onShowCellEditDialog($event, false)">
    <!--    <div class="call">-->
    <!--      <span *ngIf="cellTotals.merchandiseCount">{{ cellTotals.merchandiseCount > 1 ? cellTotals.merchandiseCount : '' }}-->
    <!--        M</span>-->
    <!--      <span *ngIf="cellTotals.ordersCount">{{ cellTotals.ordersCount > 1 ? cellTotals.ordersCount : '' }}O</span>-->
    <!--      <span *ngIf="cellTotals.salesCount">{{ cellTotals.salesCount > 1 ? cellTotals.salesCount : '' }}S</span>-->
    <!--    </div>-->

    <div class="call" *ngFor="let call of cellCopy.calls; let last = last"
         [ngClass]="{'margin-right-5': !last, 'Routed': (visitPlan.scheduleStatus === 'PLANNED' && visitPlanAccountCallAnalysisMap[call.id]?.routed), 'Leftover': (visitPlan.scheduleStatus === 'PLANNED' && !visitPlanAccountCallAnalysisMap[call.id]?.routed), 'Risk': !!visitPlanAccountCallAnalysisMap[call.id]?.risks && !!visitPlanAccountCallAnalysisMap[call.id].risks?.length}"
         [ngbTooltip]="tooltipTmpl"
         openDelay="300"
         container="body"
         triggers="hover">
      <span class="program-indication">{{ programTypeAliasMap[$any(getFieldValue(call.programType))] }}</span>
      <span *ngIf="getFieldValue(call.destination.subtasks)?.length">A+</span>
      <span *ngIf="visitPlanAccountCallAnalysisMap[call.id]?.agentName && visitScheduleDays.length < 4"
            class="margin-left-5">{{ visitPlanAccountCallAnalysisMap[call.id]?.agentName }}
      </span>

      <ng-template #tooltipTmpl>
        <app-visit-plan-call-details [call]="call"
                                     [visitPlan]="visitPlan"
                                     [analysis]="visitPlanAccountCallAnalysisMap[call.id]"
                                     [programTypeAliasMap]="programTypeAliasMap">

        </app-visit-plan-call-details>
      </ng-template>

    </div>
    <span class="flex"></span>
    <!--    <bringoz-button *ngIf="isShowEditBtn && canEdit"-->
    <!--                    type="tertiary"-->
    <!--                    (onClick)="onShowCellEditDialog($event, false)">-->

    <!--      <bringoz-icon iconName="chevron-down" class="gray-101"></bringoz-icon>-->
    <!--    </bringoz-button>-->
  </div>
  <div class="br-body-1 font-weight-400 gray-100 flex-25 cell-text margin-left-10" *ngIf="tableFilterColumns.isDisplayServiceTime">
    <!-- Service Time -->
    <div
      *ngIf="cellTotals.hasAdjustedServiceTime"
      class="layout-column"
      [ngbTooltip]="(cellTotals.adjustedServiceTime | bringozTimeHHMM)"
      openDelay="300"
      container="body"
      triggers="hover">
      <span>{{ cellTotals.adjustedServiceTime | bringozTimeHHMM }}</span>
      <span class="line-through">{{ cellTotals.initialServiceTime | bringozTimeHHMM }}</span>
    </div>
    <span
      *ngIf="!cellTotals.hasAdjustedServiceTime"
      [ngbTooltip]="(cellTotals.initialServiceTime | bringozTimeHHMM)"
      openDelay="300"
      container="body"
      triggers="hover">
      {{ cellTotals.initialServiceTime | bringozTimeHHMM }}</span>
  </div>
</div>
